import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import { downloadPdf, openRedirectModal, closeRedirectModal } from "./action-creators";
import type { PdfDownloadState } from "./type";

const INITIAL_STATE: PdfDownloadState = {
    activeDownloads: [],
    errors: {},
    redirectModal: {
        isOpen: false,
        domain: null,
    },
};

type Actions = ActionType<typeof downloadPdf | typeof openRedirectModal | typeof closeRedirectModal>;

export const pdfDownloadsReducer = createReducer<PdfDownloadState, Actions>(INITIAL_STATE)
    .handleAction(downloadPdf.request, (state, { payload }) => ({
        ...state,
        activeDownloads: [...state.activeDownloads, payload.messageId],
    }))
    .handleAction(downloadPdf.success, (state, { payload }) => ({
        ...state,
        activeDownloads: state.activeDownloads.filter((id) => id !== payload.messageId),
        errors: { ...state.errors, [payload.messageId]: undefined },
    }))
    .handleAction(downloadPdf.failure, (state, { payload }) => ({
        ...state,
        activeDownloads: state.activeDownloads.filter((id) => id !== payload.messageId),
        errors: { ...state.errors, [payload.messageId]: payload.error },
    }))
    .handleAction(openRedirectModal, (state, { payload }) => ({
        ...state,
        redirectModal: {
            isOpen: true,
            domain: payload,
        },
    }))
    .handleAction(closeRedirectModal, (state) => ({
        ...state,
        redirectModal: {
            isOpen: false,
            domain: null,
        },
    }));
